import { render, staticRenderFns } from "./CartHistoryCard.vue?vue&type=template&id=f4f515e6&scoped=true&"
import script from "./CartHistoryCard.vue?vue&type=script&lang=js&"
export * from "./CartHistoryCard.vue?vue&type=script&lang=js&"
import style0 from "./CartHistoryCard.vue?vue&type=style&index=0&id=f4f515e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f515e6",
  null
  
)

export default component.exports